import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useId, } from "react";
import { cn } from "../lib/cn.js";
export function Label({ className, ...props }) {
    return _jsx("label", { className: cn("text-sm font-medium leading-none text-foreground", className), ...props });
}
export const inputClassName = "flex h-10 w-full rounded-md border border-input bg-card px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-60 aria-[invalid=true]:border-destructive";
export function Input({ className, type = "text", ...props }) {
    return _jsx("input", { type: type, className: cn(inputClassName, className), ...props });
}
export function Textarea({ className, ...props }) {
    return _jsx("textarea", { className: cn(inputClassName, "h-auto min-h-20", className), ...props });
}
/** Yerel `<select>`: klavye, ekran okuyucu ve mobil davranışı tarayıcıdan gelir. */
export function Select({ className, children, ...props }) {
    return (_jsx("select", { className: cn(inputClassName, "pr-8", className), ...props, children: children }));
}
export function Checkbox({ className, ...props }) {
    return (_jsx("input", { type: "checkbox", className: cn("size-4 rounded border-input accent-[var(--primary)]", className), ...props }));
}
const FieldContext = createContext(null);
/**
 * Alan kontrolüne bağlanacak erişilebilirlik öznitelikleri: `<Input {...useFieldControl()} />`.
 * Etiket `htmlFor`, hata ve açıklama `aria-describedby` ile kendiliğinden bağlanır.
 */
export function useFieldControl() {
    const field = useContext(FieldContext);
    if (!field)
        throw new Error("useFieldControl yalnızca <FormField> içinde kullanılabilir");
    return {
        id: field.id,
        "aria-invalid": field.invalid,
        "aria-describedby": [field.errorId, field.descriptionId].filter(Boolean).join(" ") || undefined,
        "aria-required": field.required,
    };
}
/** Etiket + kontrol + açıklama + hata. Hata `role="alert"` ile duyurulur. */
export function FormField({ label, description, error, required = false, className, children, }) {
    const id = useId();
    const context = {
        id,
        descriptionId: description ? `${id}-description` : undefined,
        errorId: error ? `${id}-error` : undefined,
        invalid: Boolean(error),
        required,
    };
    return (_jsx(FieldContext.Provider, { value: context, children: _jsxs("div", { className: cn("grid gap-1.5", className), children: [_jsxs(Label, { htmlFor: id, children: [label, required ? (_jsxs("span", { className: "text-destructive", "aria-hidden": "true", children: [" ", "*"] })) : null] }), typeof children === "function" ? _jsx(FieldRender, { render: children }) : children, description ? (_jsx("p", { id: context.descriptionId, className: "text-xs text-muted-foreground", children: description })) : null, error ? (_jsx("p", { id: context.errorId, role: "alert", className: "text-xs font-medium text-destructive", children: error })) : null] }) }));
}
function FieldRender({ render, }) {
    return render(useFieldControl());
}
//# sourceMappingURL=form.js.map